import getSearchParameters from '../../../utilities/getSearchParameters';
const getMarkersApiArgs = (tags: any, propertyType: string = 'hotel') => {
    const markersApiArgs: any = {};

    for (let i = 0; i < tags.length; i += 1) {
        markersApiArgs[`search_tags[${i}]`] = tags[i];
    }

    const mapWithArgs = Object.assign({}, markersApiArgs, getSearchParameters(propertyType));

    // TODO change how the map type is added (move this so it gets passed from the component)
    const mapType = 'date_from' in mapWithArgs && 'date_to' in mapWithArgs ? 'availability' : 'default';

    return {
        mapType,
        mapWithArgs
    };
};

export default getMarkersApiArgs;
